import http from "../http-credential";

class CredentialService {
  changePassword(data) {
    return http.post("/update-password", data);
  }

}

export default new CredentialService();